import { DateTime } from "luxon";

export class Configuration {
	restaurant: Restaurant = new Restaurant();
	terminal: Terminal = new Terminal();
	order: OrderConfiguration = new OrderConfiguration();
	tax: TaxConfiguration = new TaxConfiguration();
	card: CardConfiguration = new CardConfiguration();
	printer: PrinterCofiguration = new PrinterCofiguration();
}

export class Restaurant {
	id: number = null;
	name: string = null;
	addressLine1: string = null;
	addressLine2: string = null;
	addressLine3: string = null;
	zipCode: string = null;
	telephone: string = null;
	capacity: number = null;
	tables: number = null;
	currencyName: string = null;
	currencySymbol: string = null;
	serviceChargePercentage: number = null;
	gratuityPercentage: number = null;
	ticketFooter: string = null;
	multiLanguage: boolean = true;
	defaultLanguage: string = null;
	deliveryFee: number = null;
	freeDeliveryApplyFromAmount: number = null;
	numberOfFilterDayConfig: number = null;
	invoiceRetrySchedule: string = null;

}

export class Terminal {
	id: number = null;
	terminalNumber: number = null;
	defaultPasswordLength: number = null;
	showDatabase: boolean = null;
	enableAutoLogoff: boolean = null;
	autoLogoffTime: number = null;
	showPromptConfirm: boolean = null;
	copyToPantry: boolean = null;
	defaultFont: string = null;
	terminalLanguage: string = null;
	kitchenPrintLanguage: string = null;
	customerPrintLanguage: string = null;
	buttonHeight: string = null;
	buttonFontSize: string = null;
}

export class OrderConfiguration {
	id: number = null;
	dineInEnableTableSection: boolean = true;
	dineInEnableGuestSection: boolean = true;
	takeOutEnable: boolean = true;
	takeOutPostPaid: boolean = true;
	takeOutAlias: string = null;
	vipEnable: boolean = true;
	vipPostPaid: boolean = true;
	vipAlias: string = null;
	pickupEnable: boolean = true;
	pickupPostPaid: boolean = true;
	pickupAlias: string = null;
	homeDeliveryEnable: boolean = true;
	homeDeliveryPostPaid: boolean = true;
	homeDeliveryAlias: string = null;
	driveThruEnable: boolean = true;
	driveThruPostPaid: boolean = true;
	driveThruAlias: string = null;
	barTabEnable: boolean = true;
	barTabPostPaid: boolean = true;
	barTabAlias: string = null;
}

export class TaxConfiguration {
	id: number = null;
	includeTax: boolean = true;
}

export class CardConfiguration {
	id: number = null;
	allowMagneticSwipeCard: boolean = true;
	allowCardManualEntry: boolean = true;
	allowExternalTerminal: boolean = true;
	defaultCardEntryMethod: string = null;
	merchantGateway: string = null;
	merchantAccount: string = null;
	secretCode: string = null;
	sandboxMode: boolean = true;
	barTabLimit: number = null;
}

export class PrinterCofiguration {
	reportPrinter: ReportPrinter = new ReportPrinter();
	receiptPrinter: ReceiptPrinter = new ReceiptPrinter();
}

export class ReportPrinter {
	id: number = null;
	printerName: string = null;
}

export class ReceiptPrinter {
	id: number = null;
	printerName: string = null;
}
